import React, { useState } from 'react';

import { MenuItem } from '@material-ui/core';
import { StyledSelect } from 'screens/admin/common/QuestionBank/styles';
import { MultiSelect } from 'screens/performanceReview/components/GoalForm';
import styled from 'styled-components';
import { StyledBox, StyledTypography } from 'styles/common';

import { REVIEW_ANSWER_TYPE_MAP } from 'constants/ProjectConstants';
import theme from 'constants/theme';

import NumberRating from 'uiToolkit/NumberRating';
import StarRating from 'uiToolkit/StarRating';

const DummyAnswerOptions = ({
  question: { answerOptions, loading, answerType, width, isRequired, minOptions, maxOptions },
}) => {
  const [selectedAnswerOptions, setSelectedAnswerOptions] = useState([]);
  const submitAnswer = (param, value) => {
    setSelectedAnswerOptions(Array.isArray(value) ? value : [value]);
  };
  const value = answerOptions.filter(
    (answerItem) => selectedAnswerOptions?.map((item) => item.id).indexOf(answerItem.id) > -1
  );
  const getAnswerComponent = () => {
    switch (answerType) {
      case REVIEW_ANSWER_TYPE_MAP.MULTI_SELECT:
        return (
          <MultiSelectContainer>
            <MultiSelect
              answerOptions={answerOptions}
              selectedAnswerOptions={selectedAnswerOptions || []}
              submitAnswer={submitAnswer}
              loading={loading}
              answerType={answerType}
              width={width}
              isRequired={isRequired}
              minOptions={minOptions}
              maxOptions={maxOptions}
            />
          </MultiSelectContainer>
        );
      case REVIEW_ANSWER_TYPE_MAP.DROP_DOWN:
        return (
          <AnswerComponentContainer>
            <StyledSelect
              variant="outlined"
              displayEmpty
              value={value[0] || ''}
              MenuProps={{
                anchorOrigin: {
                  vertical: 'bottom',
                  horizontal: 'left',
                },
                transformOrigin: {
                  vertical: 'top',
                  horizontal: 'left',
                },
                getContentAnchorEl: null,
                style: { maxWidth: width },
              }}
              SelectDisplayProps={{
                style: {
                  maxHeight: '3.5rem',
                  height: '3.5rem',
                  overflowY: 'auto',
                  padding: '0.5rem 1.5rem 0.5rem 0.75rem',
                  backgroundColor: theme.palette.background.paper,
                },
              }}
              renderValue={(value) => (
                <StyledTypography style={{ whiteSpace: 'normal' }} variant="body2">
                  {value ? value.description : `Select ${isRequired ? '*' : ''}`}
                </StyledTypography>
              )}
              onChange={({ target }) => {
                submitAnswer('rating', target.value);
              }}
            >
              {answerOptions.map((option, optionIndex) => (
                <MenuItem
                  key={`menu-option-${optionIndex}`}
                  value={option}
                  style={{
                    borderBottom: `1px solid ${
                      optionIndex !== answerOptions.length - 1 ? theme.palette.borders.lightGrey : 'transparent'
                    }`,
                  }}
                >
                  <StyledTypography style={{ whiteSpace: 'normal' }} variant="body2">
                    {option.description}
                  </StyledTypography>
                </MenuItem>
              ))}
            </StyledSelect>
          </AnswerComponentContainer>
        );
      case REVIEW_ANSWER_TYPE_MAP.STAR_RATING:
        return (
          <AnswerComponentContainer>
            <StyledBox flexcontainer justifycontent="flex-start" alignitems="flex-start">
              <StarRating
                onChange={(newValue) => {
                  submitAnswer(
                    'rating',
                    answerOptions.filter((ans) => ans.displayOrder === newValue)
                  );
                }}
                max={answerOptions.length}
                prevVal={value[0]?.displayOrder || 0}
                size="smallest"
              />
              <StyledBox flexcontainer justifycontent="flex-start" alignitems="flex-start">
                {isRequired && <StyledTypography>*</StyledTypography>}
              </StyledBox>
            </StyledBox>
          </AnswerComponentContainer>
        );
      case REVIEW_ANSWER_TYPE_MAP.NUMBER_RATING:
        return (
          <AnswerComponentContainer>
            <StyledBox flexcontainer justifycontent="flex-start" alignitems="flex-start">
              <NumberRating
                data={answerOptions}
                onSelect={(selectedId) => {
                  submitAnswer(
                    'rating',
                    answerOptions.filter((ans) => ans.id === selectedId)
                  );
                }}
                selectedId={value[0]?.id || null}
                descriptionKey="score"
              />
              <StyledBox flexcontainer justifycontent="flex-start" alignitems="flex-start">
                {isRequired ? '*' : ''}
              </StyledBox>
            </StyledBox>
          </AnswerComponentContainer>
        );
      default:
        return <span>-</span>;
    }
  };
  return <>{getAnswerComponent()}</>;
};

export default DummyAnswerOptions;

const MultiSelectContainer = styled.div`
  margin-top: 3.5px;
  max-width: 400px;
`;

const AnswerComponentContainer = styled.div`
  max-width: 500px;
`;
